import { render, staticRenderFns } from "./shuwoon.vue?vue&type=template&id=fc4b4ab8&scoped=true&"
import script from "./shuwoon.vue?vue&type=script&lang=js&"
export * from "./shuwoon.vue?vue&type=script&lang=js&"
import style0 from "./shuwoon.vue?vue&type=style&index=0&id=fc4b4ab8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4b4ab8",
  null
  
)

export default component.exports